import React, { useEffect, useState } from "react";
import { createIpaSymbol, updateIpaSymbol } from "./adminIpaService";
import "../../announcement/announcement.css";
import "../../styles/content.css";

const typeOptions = ["VOWEL", "CONSONANT", "DIPHTHONG", "SUPRASEGMENTAL"];
const difficultyOptions = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];

const AdminIpaSymbolForm = ({ symbol, onSaved, onCancel }) => {
 const isEdit = !!symbol;

 const [form, setForm] = useState({
 symbol: "",
 name: "",
 type: "",
 audioUrl: "",
 mouthPositionImageUrl: "",
 exampleWord: "",
 exampleIpa: "",
 description: "",
 difficulty: "",
 sortOrder: 1,
 });

 const [loading, setLoading] = useState(false);

 useEffect(() => {
 if (symbol) {
 setForm({
 symbol: symbol.symbol || "",
 name: symbol.name || "",
 type: symbol.type || "",
 audioUrl: symbol.audioUrl || "",
 mouthPositionImageUrl: symbol.mouthPositionImageUrl || "",
 exampleWord: symbol.exampleWord || "",
 exampleIpa: symbol.exampleIpa || "",
 description: symbol.description || "",
 difficulty: symbol.difficulty || "",
 sortOrder: symbol.sortOrder || 1,
 });
 }
 }, [symbol]);

 const handleChange = (e) => {
 const { name, value } = e.target;
 setForm({ ...form, [name]: name === "sortOrder" ? Number(value) : value });
 };

 const handleSubmit = async () => {
 if (!form.symbol || !form.name || !form.type || !form.difficulty) {
 alert("Symbol, Name, Type, and Difficulty are required");
 return;
 }

 setLoading(true);
 const res = isEdit
 ? await updateIpaSymbol(symbol.id, form)
 : await createIpaSymbol(form);

 if (res.status === 200 || res.status === 201) {
 onSaved();
 } else {
 alert(res.message || "Operation failed");
 }
 setLoading(false);
 };

 return (
 <div className="modal-overlay">
 <div className="modal-content">
 <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
 <div className="form-header">
 <h2>{isEdit ? "Edit IPA Symbol" : "Create IPA Symbol"}</h2>
 </div>

 <div className="form-grid">
 <div className="form-group">
 <label>Symbol *</label>
 <input name="symbol" placeholder="e.g. ʃ" value={form.symbol} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Name *</label>
 <input name="name" placeholder="e.g. voiceless postalveolar fricative" value={form.name} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Type *</label>
 <select name="type" value={form.type} onChange={handleChange}>
 <option value="">Select Type</option>
 {typeOptions.map((opt) => (
 <option key={opt} value={opt}>{opt}</option>
 ))}
 </select>
 </div>

 <div className="form-group">
 <label>Difficulty *</label>
 <select name="difficulty" value={form.difficulty} onChange={handleChange}>
 <option value="">Select Difficulty</option>
 {difficultyOptions.map((opt) => (
 <option key={opt} value={opt}>{opt}</option>
 ))}
 </select>
 </div>

 <div className="form-group">
 <label>Example Word</label>
 <input name="exampleWord" placeholder="e.g. ship" value={form.exampleWord} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Example IPA</label>
 <input name="exampleIpa" placeholder="e.g. /ʃɪp/" value={form.exampleIpa} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Sort Order</label>
 <input name="sortOrder" type="number" value={form.sortOrder} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Audio URL</label>
 <input name="audioUrl" placeholder="https://..." value={form.audioUrl} onChange={handleChange} />
 </div>

 <div className="form-group full-width">
 <label>Mouth Position Image URL</label>
 <input name="mouthPositionImageUrl" placeholder="https://..." value={form.mouthPositionImageUrl} onChange={handleChange} />
 </div>

 <div className="form-group full-width">
 <label>Description</label>
 <textarea name="description" placeholder="How to produce this sound..." value={form.description} onChange={handleChange} rows={3} />
 </div>
 </div>

 <div className="form-actions">
 <button className="btn primary" onClick={handleSubmit} disabled={loading}>
 {loading ? "Saving..." : isEdit ? "Update" : "Create"}
 </button>
 <button className="btn secondary" onClick={onCancel} disabled={loading}>
 Cancel
 </button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default AdminIpaSymbolForm;
